import { useNavigate, useParams } from '@ksyos/router';
import { translateKey } from '../../../../translate';
import { Header, SubHeader } from '../../../elements/common';
import { FixedWidthTemplate } from '../../../templates/FixedWidthTemplate';
import { PatientMergeSso } from './PatientMergeSso';

export function PatientMergeSsoWrapper() {
    const navigate = useNavigate();
    const { patientId, ssoId } = useParams() as { patientId: string; ssoId: string };

    return (
        <>
            <FixedWidthTemplate>
                <Header content={translateKey('txcs.conflict')} />
                <SubHeader text={translateKey('txcs.selectCorrectInformation')} />
                <div className="form-container">
                    <PatientMergeSso
                        onClose={async () => {
                            navigate(`/patients/${patientId}`);
                        }}
                        patientId={patientId}
                        ssoMergeId={ssoId}
                    />
                </div>
            </FixedWidthTemplate>
        </>
    );
}
